import html2canvas from 'html2canvas'

export const html2Images = async (
  nodes: NodeListOf<HTMLElement> | HTMLElement[]
): Promise<string[]> => {
  return await Promise.all(
    Array.from(nodes).map(async node => {
      const canvas = await html2canvas(node, { scale: 2 })
      return canvas.toDataURL('image/png', 1)
    })
  )
}
